import { render, staticRenderFns } from "./ShipperCourierGenerate.vue?vue&type=template&id=cc74d034"
import script from "./ShipperCourierGenerate.vue?vue&type=script&lang=js"
export * from "./ShipperCourierGenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports